import { createStyles, makeStyles } from '@material-ui/core'

export const useReferralsCardStyles = makeStyles(
  (theme) =>
    createStyles({
      container: {
        textAlign: 'center'
      },

      countReferrals: {
        marginBottom: 25,
        fontSize: 42,
        fontWeight: 600,
        lineHeight: 1.2,
        color: theme.palette.grey[900]
      }
    }),
  {
    name: 'ReferralsCard'
  }
)
